import React, { useEffect, useState } from "react";
import ModalComp from "components/ModalComp";
import Title from "antd/es/typography/Title";
import ButtonIcon from "components/ButtonComp";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import useSosStatuses from "hooks/useSosStatuses";
import useForm from "hooks/useForm";
import InputComp from "components/InputComp";
import * as XLSX from 'xlsx';
import { ISosStatus } from "models/Sos";
import { Spin, message } from 'antd';
import useLoading from "hooks/useLoading";

type Props = {
    onClose: () => void;
}

const HistoricalSosXlsx: React.FC<Props> = ({ onClose }: Props) => {
    const currentDate = new Date();
    const startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)
        .toISOString()
        .slice(0, 10);
    const endDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0)
        .toISOString()
        .slice(0, 10);
    const hookForm = useForm<Record<string, any>>({ startDate, endDate });
    const { startDate: formStartDate, endDate: formEndDate } = hookForm.form;
    const hookSosStatuses = useSosStatuses({ startDate: formStartDate, endDate: formEndDate });
    const [isExporting, setIsExporting] = useState(false);
    const hookLoading = useLoading({ defaultLoading: false });

    useEffect(() => {
        if (hookSosStatuses.loading) {
            message.info({ content: "Este proceso puede demorar unos segundos...", key: "download" });
        }
    }, [hookSosStatuses.loading]);
    useEffect(() => {
        console.log("🚀 ~ isExporting:", isExporting)
    }, [isExporting]);
    useEffect(() => {
        console.log("🚀 ~ hookLoading:", hookLoading.isLoading)
    }, [hookLoading]);


    const handleDownload = async () => {
        
        
        try {
            setIsExporting(true);
        hookLoading.start();
        message.loading({ content: 'Generando archivo Excel...', key: 'download' });
            const exportData = hookSosStatuses.data.map((item: ISosStatus) => ({
                'ID': item.id,
                'Fecha': item.created_at,
                'SOS': item.sos_id,
                'Descripción': item.so.description,
                'Fecha de recepción': item.received_at,
                'Peer': item.data.Peer,
                'Evento': item.data.Event,
                'PollTime': item.data.PollTime,
                'Privilege': item.data.Privilege,
                'PeerStatus': item.data.PeerStatus,
                'ChannelType': item.data.ChannelType,
                'ACL': item.data.RawResponseData?.ACL,
                'Codecs': item.data.RawResponseData?.Codecs,
                'Status': item.data.RawResponseData?.Status,
                'ToHost': item.data.RawResponseData?.ToHost,
                'Context': item.data.RawResponseData?.Context,
                'Dynamic': item.data.RawResponseData?.Dynamic,
                'AMAflags': item.data.RawResponseData?.AMAflags,
                'Callerid': item.data.RawResponseData?.Callerid,
                'Language': item.data.RawResponseData?.Language,
                'Response': item.data.RawResponseData?.Response,
                'ToneZone': item.data.RawResponseData?.ToneZone,
                'Callgroup': item.data.RawResponseData?.Callgroup,
                'MaxCallBR': item.data.RawResponseData?.MaxCallBR,
                'RegExpire': item.data.RawResponseData?.RegExpire,
                'Address-IP': item.data.RawResponseData?.['Address-IP'],
                'Busy-level': item.data.RawResponseData?.['Busy-level'],
                'Call-limit': item.data.RawResponseData?.['Call-limit'],
                'MOHSuggest': item.data.RawResponseData?.MOHSuggest,
                'ObjectName': item.data.RawResponseData?.ObjectName,
                'Parkinglot': item.data.RawResponseData?.Parkinglot,
                'SIP-T.38EC': item.data.RawResponseData?.['SIP-T.38EC'],
                'Channeltype': item.data.RawResponseData?.Channeltype,
                'Description': item.data.RawResponseData?.Description,
                'Maxforwards': item.data.RawResponseData?.Maxforwards,
                'Pickupgroup': item.data.RawResponseData?.Pickupgroup,
                'QualifyFreq': item.data.RawResponseData?.QualifyFreq,
                'Reg-Contact': item.data.RawResponseData?.['Reg-Contact'],
                'SIP-Comedia': item.data.RawResponseData?.['SIP-Comedia'],
                'SecretExist': item.data.RawResponseData?.SecretExist,
                'Address-Port': item.data.RawResponseData?.['Address-Port'],
                'LastMsgsSent': item.data.RawResponseData?.LastMsgsSent,
                'SIP-DTMFmode': item.data.RawResponseData?.['SIP-DTMFmode'],
                'SIP-RTCP-Mux': item.data.RawResponseData?.['SIP-RTCP-Mux'],
                'SIP-Sess-Min': item.data.RawResponseData?.['SIP-Sess-Min'],
                'TransferMode': item.data.RawResponseData?.TransferMode,
                'VoiceMailbox': item.data.RawResponseData?.VoiceMailbox,
                'SIP-UserPhone': item.data.RawResponseData?.['SIP-UserPhone'],
                'SIP-Useragent': item.data.RawResponseData?.['SIP-Useragent'],
                'ChanObjectType': item.data.RawResponseData?.ChanObjectType,
                'MD5SecretExist': item.data.RawResponseData?.MD5SecretExist,
                'SIP-Encryption': item.data.RawResponseData?.['SIP-Encryption'],
                'SIP-Forcerport': item.data.RawResponseData?.['SIP-Forcerport'],
                'SIP-RTP-Engine': item.data.RawResponseData?.['SIP-RTP-Engine'],
                'CID-CallingPres': item.data.RawResponseData?.['CID-CallingPres'],
                'Default-addr-IP': item.data.RawResponseData?.['Default-addr-IP'],
                'Named Callgroup': item.data.RawResponseData?.['Named Callgroup'],
                'SIP-CanReinvite': item.data.RawResponseData?.['SIP-CanReinvite'],
                'SIP-DirectMedia': item.data.RawResponseData?.['SIP-DirectMedia'],
                'SIP-Sess-Timers': item.data.RawResponseData?.['SIP-Sess-Timers'],
                'SIP-T.38Support': item.data.RawResponseData?.['SIP-T.38Support'],
                'SIP-TextSupport': item.data.RawResponseData?.['SIP-TextSupport'],
                'Default-Username': item.data.RawResponseData?.['Default-Username'],
                'SIP-AuthInsecure': item.data.RawResponseData?.['SIP-AuthInsecure'],
                'SIP-PromiscRedir': item.data.RawResponseData?.['SIP-PromiscRedir'],
                'SIP-Sess-Expires': item.data.RawResponseData?.['SIP-Sess-Expires'],
                'SIP-Sess-Refresh': item.data.RawResponseData?.['SIP-Sess-Refresh'],
                'SIP-T.38MaxDtgrm': item.data.RawResponseData?.['SIP-T.38MaxDtgrm'],
                'SIP-VideoSupport': item.data.RawResponseData?.['SIP-VideoSupport'],
                'Default-addr-port': item.data.RawResponseData?.['Default-addr-port'],
                'Named Pickupgroup': item.data.RawResponseData?.['Named Pickupgroup'],
                'RemoteSecretExist': item.data.RawResponseData?.RemoteSecretExist,
                'SIP-Use-Reason-Header': item.data.RawResponseData?.['SIP-Use-Reason-Header']
            }));

            // Create worksheet
            const ws = XLSX.utils.json_to_sheet(exportData);

            // Ajustar el ancho de las columnas
            const columnWidths = [
                { wch: 10 },  // ID
                { wch: 30 },  // Fecha
                { wch: 10 },  // SOS
                { wch: 20 },  // Descripción
                { wch: 30 },  // Fecha de recepción
                { wch: 20 },  // Peer
                { wch: 20 },  // Evento
                { wch: 20 },  // PollTime
                { wch: 20 },  // Privilege
                { wch: 20 },  // PeerStatus
                { wch: 20 },  // ChannelType
                { wch: 20 },  // ACL
                { wch: 20 },  // Codecs
                { wch: 20 },  // Status
                { wch: 20 },  // ToHost
                { wch: 20 },  // Context
                { wch: 20 },  // Dynamic
                { wch: 20 },  // AMAflags
                { wch: 20 },  // Callerid
                { wch: 20 },  // Language
                { wch: 20 },  // Response
                { wch: 20 },  // ToneZone
                { wch: 20 },  // Callgroup
                { wch: 20 },  // MaxCallBR
                { wch: 20 },  // RegExpire
                { wch: 20 },  // Address-IP
                { wch: 20 },  // Busy-level
                { wch: 20 },  // Call-limit
                { wch: 20 },  // MOHSuggest
                { wch: 20 },  // ObjectName
                { wch: 20 },  // Parkinglot
                { wch: 20 },  // SIP-T.38EC
                { wch: 20 },  // Channeltype
                { wch: 30 },  // Description
                { wch: 20 },  // Maxforwards
                { wch: 20 },  // Pickupgroup
                { wch: 20 },  // QualifyFreq
                { wch: 30 },  // Reg-Contact
                { wch: 20 },  // SIP-Comedia
                { wch: 20 },  // SecretExist
                { wch: 20 },  // Address-Port
                { wch: 20 },  // LastMsgsSent
                { wch: 20 },  // SIP-DTMFmode
                { wch: 20 },  // SIP-RTCP-Mux
                { wch: 20 },  // SIP-Sess-Min
                { wch: 20 },  // TransferMode
                { wch: 20 },  // VoiceMailbox
                { wch: 20 },  // SIP-UserPhone
                { wch: 30 },  // SIP-Useragent
                { wch: 20 },  // ChanObjectType
                { wch: 20 },  // MD5SecretExist
                { wch: 20 },  // SIP-Encryption
                { wch: 20 },  // SIP-Forcerport
                { wch: 20 },  // SIP-RTP-Engine
                { wch: 20 },  // CID-CallingPres
                { wch: 20 },  // Default-addr-IP
                { wch: 20 },  // Named Callgroup
                { wch: 20 },  // SIP-CanReinvite
                { wch: 20 },  // SIP-DirectMedia
                { wch: 20 },  // SIP-Sess-Timers
                { wch: 20 },  // SIP-T.38Support
                { wch: 20 },  // SIP-TextSupport
                { wch: 20 },  // Default-Username
                { wch: 20 },  // SIP-AuthInsecure
                { wch: 20 },  // SIP-PromiscRedir
                { wch: 20 },  // SIP-Sess-Expires
                { wch: 20 },  // SIP-Sess-Refresh
                { wch: 20 },  // SIP-T.38MaxDtgrm
                { wch: 20 },  // SIP-VideoSupport
                { wch: 20 },  // Default-addr-port
                { wch: 20 },  // Named Pickupgroup
                { wch: 20 },  // RemoteSecretExist
                { wch: 20 }   // SIP-Use-Reason-Header
            ];
            ws['!cols'] = columnWidths;

            // Create workbook
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Datos SOS');

            // Generate filename with timestamp
            const fileName = `Historical_SOS_${new Date().getTime()}.xlsx`;

            // Save the file
            XLSX.writeFile(wb, fileName);
            message.success({ content: 'Archivo Excel generado exitosamente', key: 'download' });
        } catch (error) {
            console.error('Error al exportar a XLSX:', error);
            message.error({ content: 'Error al generar el archivo Excel', key: 'download' });
        } finally {
            setIsExporting(false);
            hookLoading.end();
        }
    }

    return (<ModalComp
        title={<Title level={3}>Reporte Histórico SOS</Title>}
        width={400}
        onClose={onClose}
        footer={[
            <div key="footer-content" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
                <ButtonIcon
                    key={1}
                    name={isExporting ? "Generando Excel..." : "Descargar Excel"}
                    icon={faFileExcel}
                    variant='outline-success'
                    onClick={handleDownload}
                    disabled={isExporting || hookSosStatuses.loading}
                />
                {isExporting && <Spin size="small" />}
            </div>
        ]}
    >
        <InputComp value={hookForm.form?.startDate} name='startDate' title='Fecha de inicio (opcional)' type='date' onChange={hookForm.handleChange} disabled={isExporting || hookSosStatuses.loading} /><br />
        <InputComp value={hookForm.form?.endDate} name='endDate' title='Fecha de fin (opcional)' type='date' onChange={hookForm.handleChange} disabled={isExporting || hookSosStatuses.loading} />
    </ModalComp>);
}

export default HistoricalSosXlsx;